import { View, Text, ImageBackground, Pressable } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import DropDownPicker from 'react-native-dropdown-picker'
import { useNavigation } from '@react-navigation/native';
import alert from './../alert'
import GlobalStyles from './../style';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const Grageas = ({route}) => {
    const navigation = useNavigation();
    useLayoutEffect(() => {
      navigation.setOptions({
          headerShown: true,
          headerTitle: transl('Roster.grageas', lang)
      })
    }, []);

    lang = dr.idiomas[useSelector((state) => state.language)].value

    const data = route.params != null ? JSON.parse(route.params) : null
    let myPlayers = []
    if(data !== undefined && data) {
        for(let i = 0; i < data.teams[0].players.length; i++){
          myPlayers[i] = {
            label: data.teams[0].players[i].name,
            value: i
          }
        }
    }
    const grageasRestantes = data.profile.grageas
    const skills = [
        {label:transl('Roster.precision', lang),value:0},
        {label:transl('Roster.reflejos', lang),value:1},
        {label:transl('Roster.manejo', lang),value:2},
        {label:transl('Roster.fuerza', lang),value:3},
        {label:transl('Roster.resistencia', lang),value:4},
        {label:transl('Roster.vision', lang),value:5},
        {label:transl('Roster.comunicacion', lang),value:6}
    ]

    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(null);
    const [items, setItems] = useState(myPlayers);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [open2, setOpen2] = useState(false);
    const [value2, setValue2] = useState(null);
    const [items2, setItems2] = useState(skills);
    const [selectedIndex2, setSelectedIndex2] = useState(null);

  return (
    <View style={{height:'100%'}}>
      <ImageBackground source={require('./../img/background4.png')} resizeMode="cover" style={{flex:1}}>
        <View style={{flex:1, justifyContent:'center'}}>
          <View>
            <View style={{marginHorizontal:'auto'}}>
                <Text style={{textAlign:'center',fontWeight:'bold',fontSize:22}}>{transl('Grageas.elijeUnJugador', lang)}</Text>
            </View>
            <View style={{ flex: 1, marginTop: 25, marginHorizontal: 25 }}>
              {/* Primer dropdown */}
              <View style={{ zIndex: 3000 }}>
                <DropDownPicker
                  open={open}
                  value={value}
                  items={items}
                  setOpen={setOpen}
                  setValue={setValue}
                  setItems={setItems}
                  zIndex={3000}
                  dropDownContainerStyle={{
                    zIndex: 3000,
                  }}
                  onSelectItem={item => setSelectedIndex(item.value)}
                  autoScroll
                />
              </View>

              {/* Segundo dropdown */}
              <View style={{ zIndex: 2000, marginTop: 15 }}>
                <DropDownPicker
                  open={open2}
                  value={value2}
                  items={items2}
                  setOpen={setOpen2}
                  setValue={setValue2}
                  setItems={setItems2}
                  zIndex={2000}
                  dropDownContainerStyle={{
                    zIndex: 2000
                  }}
                  onSelectItem={item => setSelectedIndex2(item.value)}
                  autoScroll
                />
              </View>

              {/* Ahora tu texto de “grageas restantes” */}
              <View style={{marginBottom:15, marginTop:15, marginHorizontal:25,zIndex:0}}>
                  <Pressable
                  disabled={value == null || value2 == null || grageasRestantes < 1}
                  style={(value == null || value2 == null || grageasRestantes < 1) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain}
                  onPress={() => {give(data,selectedIndex,selectedIndex2,navigation,grageasRestantes)}}>
                    <Text style={GlobalStyles.textForButtonMain}>{transl('Grageas.darGragea', lang)}</Text>
                </Pressable>
              </View>
              <View style={{ marginLeft:'auto',marginRight:'auto', marginTop: 25 }}>
                <Text style={{ fontStyle: 'italic', fontSize: 28 }}>
                  {transl('Grageas.grageasRestantes', lang)}{grageasRestantes}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </ImageBackground>
    </View>
  )
}

function give(data,ssi,ssi2,navigation,grageas) {
    if(ssi == null){
      alert(transl('General.info', lang),"Debes escoger un jugador",[
        {text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"},
      ])
      return
    } else if (grageas < 1) {
      alert(transl('General.info', lang),"No te quedan grageas",[
        {text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"},
      ])
      return
    }
    if(data === undefined || !data) return;

    console.log("mejorando "+ssi2+" de "+ssi)
    data.teams[0].players[ssi].skills[ssi2] += 5
    let randoms = generateRandomNumber(0,4,2)
    while ((ssi2 == randoms[0] || ssi2 == randoms[1]) || randoms[0] == randoms[1]) randoms = generateRandomNumber(0,4,2)
    console.log("randoms son "+randoms[0]+" y "+randoms[1])
    data.teams[0].players[ssi].skills[randoms[0]] += 3
    data.teams[0].players[ssi].skills[randoms[1]] += 2

    if(data.teams[0].players[ssi].skills[ssi2] > 99) data.teams[0].players[ssi].skills[ssi2] = 99
    if(data.teams[0].players[ssi].skills[randoms[0]] > 99) data.teams[0].players[ssi].skills[randoms[0]] = 99
    if(data.teams[0].players[ssi].skills[randoms[1]] > 99) data.teams[0].players[ssi].skills[randoms[1]] = 99
  
    data.profile.grageas -= 1

    saveData(data,data.teams[0].players[ssi].name,navigation)
}

function saveData(data,player,navigation){
    const text = transl('Grageas.haRecibido', lang,[player])
    const storeData = async (data) => {
      try {
        const jsonValue = JSON.stringify(data)
        await AsyncStorage.setItem('equipos', jsonValue)
        alert(transl('General.info', lang),text,[{text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"}])
        navigation.navigate('HomeScreen')
      } catch (e) {
        console.log("error saving file")
        console.log(e)
      }
    }
  
    storeData(data);
}

function generateRandomNumber(from, to, howMany) {
    const diferencia = to - from + 1;
    let numbers = [];
    for(let i = 0; i < howMany; i++) {
      numbers[i] = Math.floor(Math.random() * diferencia + from);
    }
    return numbers;
}

export default Grageas